import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ModelUsageResponse = components["schemas"]["ModelUsageResponse"];

/** GET /v1/me/model-usage — recently used models, most recent first. */
export async function listModelUsage(): Promise<ModelUsageResponse> {
  return unwrap(await api.GET("/v1/me/model-usage"));
}
